import { Bindable } from "@eusoft/webapp-core";
import { Component, IComponentOptions, ITemplateContext } from "@eusoft/webapp-core";
import { Class, forModel } from "@eusoft/webapp-jsx";
import { IPoint } from "../helpers/Geometry";
import "./SliceBar.scss";
import { onDrag } from "../helpers/TouchHelper";

export interface ISliceBarOptions extends IComponentOptions {

    min?: Bindable<number>;

    max?: Bindable<number>;

    sliceSize?: Bindable<number>;

    value?: Bindable<number>;

    orientation?: "horizonatal"| "vertical";
}

export class SliceBar extends Component<ISliceBarOptions> {

    constructor(options: ISliceBarOptions) {
        super();

        this.init(SliceBar, {
            min: 0,
            max: 1,
            value: 0,
            sliceSize: 0.5,
            orientation: "horizonatal",
            template: forModel((m: this) => <div className={m.className}>
                <Class name={m.orientation }/>
                <div className="bar"
                    style-left={m.orientation == "horizonatal" ? (((m.value - m.min) / (m.max - m.min) * 100) + "%") : ""}
                    style-width={m.orientation == "horizonatal" ? (((m.sliceSize / (m.max - m.min)) * 100) + "%") : ""}
                    style-top={m.orientation == "vertical" ? (((m.value - m.min) / (m.max - m.min) * 100) + "%") : ""}
                    style-height={m.orientation == "vertical" ? (((m.sliceSize / (m.max - m.min)) * 100) + "%") : ""}>
                    <span className="handle l-handle"></span>
                    <span className="handle r-handle"></span>
                </div>
            </div>),
            ...options,
        });
    }

    override mount(ctx: ITemplateContext) {
        super.mount(ctx);

        let startValue: number;
        let startSlice: number;

        onDrag(ctx.element,

            (pos, button, ev) => {

                const tagetClass = (ev.target as HTMLElement).classList;
                if (tagetClass.contains("slice-bar"))
                    return false;

                startValue = this.value;

                startSlice = this.sliceSize;

                return true;
            },

            (pos, startPos, ev) => {

                let dx, dv: number;

                if (this.orientation == "horizonatal") {
                    dx = pos.x - startPos.x;
                    dv = (dx / ctx.element.clientWidth) * (this.max - this.min);
                }
                else if (this.orientation == "vertical") {
                    dx = pos.y - startPos.y;
                    dv = (dx / ctx.element.clientHeight) * (this.max - this.min);
                }

                const tagetClass = (ev.target as HTMLElement).classList;

                if (tagetClass.contains("l-handle")) {
                    const newSlice = startSlice - dv;
                    const newValue = startValue + dv;
                    if (newSlice >= 0 && newValue >= this.min) {
                        this.sliceSize = Math.min(newSlice, this.max - this.value);
                        this.value = newValue;
                    }
                }
                else if (tagetClass.contains("r-handle")) {
                    const newSlice = startSlice + dv;
                    if (newSlice >= 0) {
                        this.sliceSize = Math.min(newSlice, this.max - this.value);
                    }

                }
                else if (tagetClass.contains("bar"))
                    this.value = Math.min(Math.max(this.min, startValue + dv), this.max - this.sliceSize);

                return true;
            },
            () => {

                return true;
            }
        );
    }

    min: number;

    max: number;

    sliceSize: number;

    value: number;

    orientation?: "horizonatal" | "vertical";
}